export default __webpack_public_path__ + "static/media/acceY.092b9c25.svg";